import { useEffect, useState } from 'react';

import { MessageBus } from '../../bus/BusChannel/MessageBus';
import { ChannelNames, Channels } from '../../channels/Channels';

export const useMessageBusData = <
  N extends ChannelNames,
  C extends Channels[N],
  T extends C['topic']
>(
  topic: T,
  busChannel: MessageBus<N, C>
) => {
  const [data, setData] = useState<
    | Extract<
        C,
        {
          topic: T;
        }
      >['payload']
    | undefined
  >();

  useEffect(() => {
    const unsubscribe = busChannel.subscribe(topic, (payload) => {
      setData(payload);
    });

    return () => {
      unsubscribe();
    };
  }, [busChannel, topic]);

  return data;
};
